import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { dateAdd } from "../../helpers/dateHelpers";
import { BaseComponent } from '../core/BaseComponent';
import { DatePickerCustomInput } from "./DatePickerCustomInput";

const day = 1000 * 60 * 60 * 24;

export enum DateNavigatorType {
    TypeDate = 1,
    TypeMonth = 2
}

interface DateNavigatorProps {
    value?: Date | null;
    type: DateNavigatorType;
    onChange: (value: Date | null) => void
}
interface DateNavigatorState {
    value?: Date | null;
    type: DateNavigatorType,
    dateFormat: string;
}
export class DateNavigator extends BaseComponent<DateNavigatorProps, DateNavigatorState> {
    constructor(props: DateNavigatorProps) {
        super(props);
        let dateFormat = "iiii d MMMM yyyy";
        if (this.props.type === DateNavigatorType.TypeMonth) {
            dateFormat = "MMMM yyyy";
        }
        this.state = {
            value: this.props.value,
            type: this.props.type,
            dateFormat
        };
    }
    addMonths(date: Date, months: number): Date {
        date.setDate(1);
        date.setMonth(date.getMonth() + months); // year is auto-corrected
        return new Date(date);
    }
    prevDate() {
        if (this.state.type === DateNavigatorType.TypeMonth) {
            this.handleChange(this.addMonths(this.state.value || new Date(), -1));
        } else {
            this.handleChange(dateAdd(this.state.value, -day));
        }
    }
    nextDate() {
        if (this.state.type === DateNavigatorType.TypeMonth) {
            this.handleChange(this.addMonths(this.state.value || new Date(), 1));
        } else {
            this.handleChange(dateAdd(this.state.value, day));
        }
    }
    handleChange(value: Date | null) {
        if (value !== this.state.value) {
            this.setState({ value });
            this.props.onChange(value);
        }
    }
    static getDerivedStateFromProps(nextProps: DateNavigatorProps, prevState: DateNavigatorState): Partial<DateNavigatorState> | null {
        if (prevState.value !== nextProps.value) {
            return { value: nextProps.value };
        }
        return null;
    }
    render() {
        return (
            <div className="date-navigator">
                <div className="button-prev" onClick={this.prevDate.bind(this)}><FontAwesomeIcon icon={faArrowLeft} /></div>
                <div className="date-picker">
                    <DatePicker
                        customInput={<DatePickerCustomInput />}
                        todayButton={this.state.type === DateNavigatorType.TypeMonth ? "Deze maand" : "Vandaag"}
                        locale="nl-NL"
                        selected={this.state.value}
                        onChange={this.handleChange.bind(this)}
                        showMonthYearPicker={this.state.type === DateNavigatorType.TypeMonth}
                        dateFormat={this.state.dateFormat}
                    />
                </div>
                <div className="button-next" onClick={this.nextDate.bind(this)}><FontAwesomeIcon icon={faArrowRight} /></div>
            </div>
        );
    }
}
